/* eslint-disable react/no-danger */
import React, { useRef } from "react";
import { string } from "prop-types";

import Block from "@insightfulscience/atomic-react/Block";
import useSequenceLineHeight from "./useSequenceLineHeight";
import SequenceLineContainer from "./SequenceLineContainer";
import useHtmlElementInfo from "../../utils/useHtmlElementInfo";
import { useResizingEffect } from "./useResizingEffect";
import { useScrollingEffect } from "./useScrollingEffect";
import { getLineLength } from "./getLineLength";

function PlasmidSequenceViewer({ setID, plasmidID }) {
	const containerRef = useRef(null);
	const scrollRef = useRef(null);
	const overviewRef = useRef(null);
	const baseRef = useRef(0);

	const containerInfo = useHtmlElementInfo(containerRef);
	const lineLength = containerInfo != null ? getLineLength(containerInfo.clientWidth) : 0;
	const lineHeightData = useSequenceLineHeight(setID, plasmidID, lineLength);
	const scrollInfo = useHtmlElementInfo(scrollRef, [lineHeightData]);

	useResizingEffect(overviewRef, scrollRef, baseRef, lineHeightData);

	useScrollingEffect(
		setID,
		plasmidID,
		scrollRef,
		overviewRef,
		baseRef,
		containerInfo,
		scrollInfo,
		lineHeightData,
	);
	return (
		<Block spacing={{ my: 20 }}>
			<div id="sg-sequence-wrapper" style={{ width: "100%" }} ref={containerRef}>
				{lineHeightData && (
					<SequenceLineContainer
						scrollRef={scrollRef}
						overviewRef={overviewRef}
						{...lineHeightData}
					/>
				)}
			</div>
		</Block>
	);
}

PlasmidSequenceViewer.propTypes = {
	setID: string,
	plasmidID: string,
	plasmidFilename: string,
};

export default PlasmidSequenceViewer;
